import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Users } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DevoteeBadge = ({ className = '' }) => {
  const [count, setCount] = useState(null);

  useEffect(() => {
    let alive = true;
    axios
      .get(`${API}/stats`)
      .then((r) => alive && setCount(r.data.devotees))
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  if (count === null) return null;

  return (
    <div
      data-testid="devotee-badge"
      className={`inline-flex items-center gap-2.5 rounded-full border border-gold/40 bg-white/70 px-4 py-2 backdrop-blur-sm ${className}`}
    >
      <span className="flex h-6 w-6 items-center justify-center rounded-full bg-gold/15 text-gold-deep">
        <Users className="h-3.5 w-3.5" />
      </span>
      <span className="font-sans text-sm text-ink/75">
        <strong className="font-semibold text-gold-deep">{count.toLocaleString('en-IN')}+</strong> devotees have registered their seva
      </span>
    </div>
  );
};

export default DevoteeBadge;
